// Recover from stale-deploy chunk failures: when a new build replaces the hashed lazy
// chunks, a client loaded before the deploy 404s on its old chunk (the server returns
// index.html, which fails to parse as JS — "Unexpected token '<'"). See router/index.js.

export function isChunkLoadError(error) {
    const message = (error && error.message) || "";
    return (
        (error && error.name === "ChunkLoadError") ||
        /Loading( CSS)? chunk [\w-]+ failed/i.test(message) ||
        /Unexpected token '<'/i.test(message)
    );
}

const markerKey = (fullPath) => "chunk-reload:" + (fullPath || "");

// Reload once to the target route to pick up the new manifest; the storage marker prevents
// a reload loop when the chunk is genuinely gone (it is cleared on a successful navigation).
export function createChunkReloadHandler({ storage, reload }) {
    return (error, to) => {
        if (!isChunkLoadError(error)) return;
        const fullPath = to && to.fullPath;
        const key = markerKey(fullPath);
        if (storage.getItem(key)) return;
        storage.setItem(key, "1");
        reload(fullPath);
    };
}

export function clearChunkReloadMarker(storage, to) {
    storage.removeItem(markerKey(to && to.fullPath));
}
